(function () {
  function init() {
    const picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    const dataEl = picker.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);

    function update() {
      const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
      const selected = fieldsets.map(
        (fs) => fs.querySelector('input:checked')?.value
      );
      fieldsets.forEach((fs, optIndex) => {
        fs.querySelectorAll('input[type="radio"]').forEach((input) => {
          const test = [...selected];
          test[optIndex] = input.value;
          const match = variants.find((v) =>
            test.every((val, i) => val == null || v.options[i] === val)
          );
          const ok = !!match && match.available;
          const label =
            fs.querySelector(`label[for="${CSS.escape(input.id)}"]`) ||
            input.nextElementSibling;
          if (label) label.classList.toggle('variant-option--unavailable', !ok);
        });
      });
    }

    picker.addEventListener('change', () => setTimeout(update, 10));
    update();
  }

  document.addEventListener('DOMContentLoaded', init);
  new MutationObserver(() => {
    const p = document.querySelector('variant-radios, variant-selects');
    if (p && !p.dataset.availabilityInit) {
      p.dataset.availabilityInit = '1';
      init();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
